import { instances } from '@/services/http';
import { useMutation } from '@tanstack/vue-query';
import type { UserDashboardRegisterEventResponseType } from '@magma-app/magma-types/user-dashboard/event';

export const useRegisterEvent = () => {
  return useMutation({
    mutationFn: async ({ eventId }: { eventId: number }) => {
      const response = await instances.userDashboard.post(
        `events/${eventId}/register`
      );
      return response.data as UserDashboardRegisterEventResponseType;
    },
  });
};
